const api = {
    GET_ROLE_LIST: "/api/rolemanagement/list",
    GET_ROLE: "/api/rolemanagement/get",
    ADD_ROLE: "/api/rolemanagement/add",
    UPDATE_ROLE: "/api/rolemanagement/edit",
    DELETE_ROLE: "/api/rolemanagement/delete"
}

export default api;
